export default function getEnv() {
  //
  const domain = window?.location?.hostname;
  if (
    domain === 'test-platform.creator.ahaglobal.io' ||
    domain === 'test.platform.creator.aha.inc' ||
    domain === 'test.creator.ahacreator.com' ||
    domain === 'localhost' ||
    domain.includes('amplifyapp')
  ) {
    return 'development';
  }
  if (domain === 'creator.ahacreator.com') {
    return 'production';
  }
  return 'production';
}
